import config from "config";

type ImageQuery = {
  w?: number;
  h?: number;
  q?: number;
  fit?: "crop" | "clip" | "fill" | "fillmax";
  bg?: string;
  auto?: string;
  trim?: string;
  mode?: string;
  upscale?: boolean;
  "max-w"?: number;
  fill?: string;
  original?: boolean;
};

const IMAGE_QUALITY = {
  VERY_LOW: config.IS_CHINA_APP ? 5 : 40,
  LOW: config.IS_CHINA_APP ? 10 : 40,
  BELOW_AVERAGE: config.IS_CHINA_APP ? 40 : 40,
  AVERAGE: config.IS_CHINA_APP ? 70 : 70,
  ABOVE_AVERAGE: config.IS_CHINA_APP ? 80 : 80,
};

const getImageDimensions = (imageType = "") => {
  const queryParams: ImageQuery = {};
  switch (imageType) {
    case "thumbnail":
      queryParams.w = 200;
      queryParams.h = 600;
      queryParams.fit = "fill";
      queryParams.q = IMAGE_QUALITY.LOW;
      break;
    case "thumbnail-normal":
      queryParams.w = 200;
      queryParams.h = 200;
      queryParams.q = IMAGE_QUALITY.LOW;
      break;
    case "xx-small":
      queryParams.w = 80;
      queryParams.h = 80;
      queryParams.fit = "crop";
      queryParams.q = IMAGE_QUALITY.LOW;
      break;
    case "x-small":
      queryParams.w = 150;
      queryParams.h = 150;
      queryParams.fit = "crop";
      queryParams.q = IMAGE_QUALITY.LOW;
      break;
    case "small":
      queryParams.w = 240;
      queryParams.h = 240;
      queryParams.fit = "crop";
      queryParams.q = IMAGE_QUALITY.LOW;
      break;
    case "medium-clip":
      queryParams.w = 400;
      queryParams.h = 260;
      queryParams.fit = "clip";
      queryParams.q = IMAGE_QUALITY.BELOW_AVERAGE;
      break;
    case "medium":
      queryParams.w = 400;
      queryParams.h = 260;
      queryParams.fit = "crop";
      queryParams.q = IMAGE_QUALITY.BELOW_AVERAGE;
      break;
    case "medium-square":
      queryParams.w = 400;
      queryParams.h = 400;
      queryParams.fit = "crop";
      queryParams.q = IMAGE_QUALITY.BELOW_AVERAGE;
      break;
    case "large-clip":
      queryParams.w = 720;
      queryParams.h = 720;
      queryParams.fit = "clip";
      queryParams.q = IMAGE_QUALITY.BELOW_AVERAGE;
      break;
    case "large":
      queryParams.w = 720;
      queryParams.h = 720;
      queryParams.fit = "crop";
      queryParams.q = IMAGE_QUALITY.BELOW_AVERAGE;
      break;
    case "x-large-clip":
      queryParams.w = 1000;
      queryParams.h = 1000;
      queryParams.fit = "clip";
      queryParams.q = IMAGE_QUALITY.AVERAGE;
      break;
    case "x-large":
      queryParams.w = 1000;
      queryParams.h = 1000;
      queryParams.fit = "crop";
      queryParams.q = IMAGE_QUALITY.AVERAGE;
      break;
    case "hero":
      queryParams.w = 720;
      queryParams.h = 480;
      queryParams.fit = "crop";
      queryParams.q = IMAGE_QUALITY.ABOVE_AVERAGE;
      break;
    case "gallery-image-small":
      queryParams.w = 600;
      queryParams.fit = "crop";
      queryParams.q = IMAGE_QUALITY.AVERAGE;
      break;
    case "gallery-image-medium":
      queryParams.w = 920;
      queryParams.q = IMAGE_QUALITY.ABOVE_AVERAGE;
      break;
    case "gallery-image-large":
      queryParams.w = 1080;
      queryParams.h = 720;
      queryParams.q = IMAGE_QUALITY.AVERAGE;
      break;
    case "video-card-image":
      queryParams.w = 270;
      queryParams.h = 180;
      queryParams.q = IMAGE_QUALITY.ABOVE_AVERAGE;
      break;
    case "gallery-image-original":
      queryParams.w = 1080;
      queryParams.h = 720;
      queryParams.mode = "fill";
      queryParams.fill = "blur";
      queryParams.bg = "000";
      queryParams.q = 90;
      break;
    case "gallery-full-screen-desktop":
      queryParams.fit = "fill";
      queryParams.h = 900;

      break;
    case "gallery-full-screen-mobile":
      queryParams["w"] = 1200;
      queryParams.fit = "fill";
      break;
    case "room-type-card":
      queryParams.w = 600;
      queryParams.fit = "fill";
      queryParams.q = IMAGE_QUALITY.ABOVE_AVERAGE;
      break;
    default:
      break;
  }
  return queryParams;
};

export default getImageDimensions;
